/** A WhatsApp provider has no page of its own: installing it and its settings are sheets over the Integrations page. */
export function installWhatsappIntegrationPath(providerKey: string): string {
  return `/integrations/whatsapp/new?provider=${encodeURIComponent(providerKey)}`;
}

export function whatsappIntegrationPath(id: string): string {
  return `/integrations/whatsapp/${id}`;
}
